export interface Products {
  id: string;
  subject: string;
  title: string;
  desc: string;
  image: string;
  product: [];
}

/**
 * DELETE — Remove product by ID
 */
export async function deleteProduct(id: string) {
  if (!id) {
    throw new Error('Product id is required');
  }

  const response = await fetch(`/api/deleteproduct/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Error deleting product: ${response.statusText}`);
  }

  const data = await response.json();

  return data;
  // { success: true, message: "Product deleted successfully" }
}
